import { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { RuntimeContext } from '../../../../../../common/RuntimeContext';
import { keyBy } from 'lodash';
import cns from 'classnames';
import { attachCloudinaryOptionsToImageSource } from '../../../../../shared/utils/ImageUtils';
import VerbSelect from '../../../../../shared/components/formComponents/inputs/VerbSelect';

const CollectionEmbed = ({ currentCollection, hiddenCompanies, companies = [], companyAdminDisplay }) => {
    const config = useContext(RuntimeContext)
    const [selectedCompanyId, setSelectedCompanyId] = useState('');

    const _handleCompanyChange = (company) => {
        setSelectedCompanyId(company._id);
    };

    const _makeAvailableCompanies = () => {
        const hiddenCompaniesById = keyBy(hiddenCompanies, '_id');

        return companies.filter((company) => !hiddenCompaniesById[company._id]);
    };

    const { _id, permalink, thumbnailImageUrl = '', name, subtitle } = currentCollection;
    const url = selectedCompanyId
        ? `${config.pathsWeb.clientUrl}/directlink/${_id}/${selectedCompanyId}`
        : `${config.pathsWeb.clientUrl}/collection/${permalink}`;

    const embedString = `<a href="${url}" style = "text-decoration:none" target="_blank" >
    <table style="border:0px;max-width:600px" cellpadding="5">
      <tbody>
        <tr>
          <td>
            <img src="${attachCloudinaryOptionsToImageSource(thumbnailImageUrl, { h: 250, w: 250 })}" />
          </td>
          <td valign = "top">
            <h3>${name}</h3>
            <p>${subtitle}</p>
          </td>
        </tr>
      </tbody>
    </table>
  </a>`;

    return (
        <div className={'collection-form'}>
            <div className={'row'}>
                <h4 className={'col-12'}>Company to Embed</h4>
                <div className={cns('col-12 company-embed-dropdown', { hidden: companyAdminDisplay })}>
                    <VerbSelect
                        placeholder={'Select Company'}
                        className={'reactSelect'}
                        value={selectedCompanyId}
                        labelKey={'name'}
                        valueKey={'_id'}
                        onChange={_handleCompanyChange}
                        options={_makeAvailableCompanies()}
                        styleProps={'col-6 no-padding'}
                    />
                </div>
            </div>
        </div>
    );
};

CollectionEmbed.propTypes = {
    currentCollection: PropTypes.shape({
        permalink: PropTypes.string,
        name: PropTypes.string,
        subtitle: PropTypes.string,
        thumbnailImageUrl: PropTypes.string,
        _id: PropTypes.string
    }),
    hiddenCompanies: PropTypes.array,
    companyAdminDisplay: PropTypes.bool,
    companies: PropTypes.array
};

export default CollectionEmbed;
